import type { CreateThemeOptions } from '@annunciate/ui';

export const CUSTOM_THEME: CreateThemeOptions = {
  darkColors: {
    primary: "#90CEA7",
    accent: "#90CEA7",
  },
  lightColors: {
    primary: "#90CEA7",
    accent: "#90CEA7",
  },
  components: {
    CarouselDisplay: (_props, theme) => ({
      titleContainerStyle: {
        marginTop: 20,
      }})
  }
}
